// extracted by mini-css-extract-plugin
export var label = "_i8-2";
export var slideContainer = "_i8-0";
export var slider = "_i8-1";